<template>
  <page-view>
    <div slot="pageRight">
      <div v-if="jobType !== '国际铁路' && jobType !== '国内运输'" class="status-box flex flex-aend flex-justify bg-white plr20 ptb15 border-radius-4">
        <a-form-model layout="vertical">
          <a-row type="flex">
            <a-col class="mr30" style="width:200px;">
              <a-form-model-item label="起运港" :colon="false">
                <a-select
                  v-model="queryParams.PolID"
                  allow-clear
                  show-search
                  placeholder="请输入起运港"
                  style="width: 100%"
                  :not-found-content="null"
                  option-filter-prop="children"
                  :dropdownMatchSelectWidth="false"
                  @search="handleSearch"
                >
                  <a-select-option
                    v-for="item in orgPortList"
                    :key="item.exportCn"
                    :value="item.id"
                    @click="handleChangeL(item)"
                  >
                    {{ `${item.exportEn}/${item.exportCode}/${item.exportCn}` }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col class="mr30" style="width:200px;">
              <a-form-model-item label="目的港" :colon="false">
                <a-select
                  v-model="queryParams.PodID"
                  allow-clear
                  show-search
                  placeholder="请输入目的港"
                  style="width: 100%"
                  :not-found-content="null"
                  option-filter-prop="children"
                  :dropdownMatchSelectWidth="false"
                  @search="handleSearchPod"
                >
                  <a-select-option
                    v-for="item in orgPortListPod"
                    :key="item.exportCn"
                    :value="item.id"
                    @click="handleChangeR(item)"
                  >
                    {{ `${item.exportEn}/${item.exportCode}/${item.exportCn}` }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col>
              <a-form-model-item label="MW业务编号" :colon="false">
                <a-input v-model="queryParams.BookingNo" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
        <div class="btn-box">
          <a-button type="primary" @click="search">
            查询
          </a-button>
          <a-button class="ml15" @click="reset">
            重置
          </a-button>
        </div>
      </div>
      <div class="mt20">
        <!-- 订单列表 -->
        <a-spin :spinning="loading">
          <table-list v-if="dataList.length>0" ref="tableList" :jobType="jobType" :dataList="dataList" />
          <div v-else class="empty-box bg-white border-radius-4 flex flex-acenter flex-jcenter">
            <a-empty />
          </div>
        </a-spin>
      </div>
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
import TableList from './modules/tableList'
import { USER_INFO } from '@/store/mutation-types'
import { orderCusSearch, getExportPortList } from '@/api/order'
export default {
  name: 'OrderSearch',
  components: { PageView, TableList },
  data () {
    return {
      queryParams: {},
      jobType: '',
      userData: '',
      dataList: [],
      orgPortList: [],
      orgPortListPod: [],
      loading: false
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    }
  },
  created () {
    this.jobType = this.$route.params.type
    // this.userData = this.$route.params.data
    // if (this.userData) {
    //   const userData = JSON.parse(this.userData)
    //   this.$store.commit('SET_INFO', userData)
    //   this.$ls.set(ACCESS_TOKEN, userData.Token)
    //   this.$ls.set(USER_INFO, userData)
    //   this.$router.push({
    //     path: '/orderSearch/国际海运'
    //   })
    // }
  },
  mounted() {
    // this.$store.commit('SET_INFO', this.userInfo)
  },
  methods: {
    search () {
      if (this.jobType === '国际铁路' || this.jobType === '国内运输') {

      } else {
        this.queryParams.Job_TypeName = this.jobType
        this.loading = true
        orderCusSearch(this.queryParams).then(res => {
          this.dataList = res.Data.List || []
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    reset () {
      this.queryParams = {}
      this.search()
    },
    handleSearch (value) {
      getExportPortList({ fuzzyName: value || '', page: 1, size: 40 }).then((res) => {
        this.orgPortList = res.data
      })
      // if (value && value !== '') {
      // } else {
      //   getExportPortList({ fuzzyName: value || '', page: 1, size: 40, ecCode: 'CN' }).then((res) => {
      //     this.orgPortList = res.data
      //   })
      // }
    },
    handleSearchPod (value) {
      getExportPortList({ fuzzyName: value || '', page: 1, size: 40 }).then((res) => {
        this.orgPortListPod = res.data
      })
    },
    handleChangeL (item) {
      this.queryParams.Pol = item.exportEn
    },
    handleChangeR (item) {
      this.queryParams.Pod = item.exportEn
    }
  }
}
</script>
<style lang="less" scoped>
.empty-box {
  height: 200px;
}
</style>
